import { Alert, Typography } from '@mui/material';
import { ExtendedDialog } from 'ui-component/extended/ExtendedDialog';
import { useState } from 'react';
import { useDeleteTagMutation } from 'store/slices/clientV2/tags';
import { TagSchema } from 'types/clientV2/tag';
import { appPermissionAccessLevels } from 'types/apps';
import { ALL_APPS } from 'constants/appConstants';
import Chip from 'ui-component/extended/Chip';

interface DeleteTagDialogProps {
  open: boolean;
  onClose: () => void;
  tag: TagSchema | null;
}

const DeleteTagDialog = ({ open, onClose, tag }: DeleteTagDialogProps) => {
  const [deleteTag] = useDeleteTagMutation();
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (!tag) return;
    setError(null);
    setIsSubmitting(true);

    try {
      await deleteTag({ ids: [tag.id] }).unwrap();
      onClose();
    } catch (err) {
      setError('Failed to delete tag');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ExtendedDialog
      open={open}
      title="Delete Tag"
      onCloseDialog={onClose}
      submitButtonCopy="Delete"
      submitButtonColor="error"
      onSubmit={handleDelete}
      isSubmitting={isSubmitting}
      isForm
      formSubmitError={error}
      permissionScope={{
        app: ALL_APPS.PROPERTIES.id,
        accessLevel: appPermissionAccessLevels.edit,
      }}
    >
      <Typography variant="body1" sx={{ mb: 2 }}>
        Are you sure you want to delete this tag?
      </Typography>

      {tag && (
        <Chip
          label={tag.name}
          chipcolor={tag.color}
          type="tag"
          sx={{ mb: 2 }}
        />
      )}

      <Alert severity="warning">This action cannot be undone.</Alert>
    </ExtendedDialog>
  );
};

export default DeleteTagDialog;
